import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar } = FiIcons;

const AuthorityCard = ({ review, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.08 }}
      whileHover={{ y: -3, boxShadow: '0 0 28px rgba(212,175,55,0.3)' }}
      className="flex flex-col rounded-xl bg-white/10 backdrop-blur-md border border-gold/50 transition-all duration-300"
    >
      {/* Badge */}
      <div className="px-5 pt-5 pb-0">
        <span
          className="inline-flex items-center font-michroma text-[8px] tracking-widest uppercase px-3 py-1 rounded-full"
          style={{ background: '#D4AF37', color: '#4A0E0E', letterSpacing: '0.15em' }}
        >
          ✦ Critics Review
        </span>
      </div>

      <div className="flex flex-col flex-grow px-5 pb-5 pt-3">
        {/* Stars */}
        <div className="flex items-center gap-0.5 mb-3">
          {[...Array(5)].map((_, i) => (
            <SafeIcon key={i} icon={FiStar} className="w-3.5 h-3.5 text-gold" style={{ fill: '#D4AF37', stroke: 'none' }} />
          ))}
        </div>

        {/* Quote */}
        <blockquote className="flex-grow mb-4">
          <p className="font-lexend text-sm leading-relaxed text-cream font-medium">
            "{review.quote}"
          </p>
        </blockquote>

        {/* Reviewer */}
        <div className="border-t border-gold/20 pt-3">
          <p className="font-michroma text-gold text-[11px] tracking-wider uppercase">{review.reviewer}</p>
          <p className="font-lexend text-gold/60 text-[10px] mt-0.5 uppercase tracking-widest">
            {review.title} · {review.experience}
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default AuthorityCard;